export default "__VITE_ASSET__B8p_BrlN__"